export type ReturnItem = {
  id: string;
  line_item_id: number;
  return_reason?: number;
  exchange_variant_id?: number;
};

export type Money = {
  amount: number;
  currency_code: string;
};

export type UpsellExchange = {
  variant_id: number;
  product_image: string | null;
  variant_image: string | null;
  product_title: string;
  title: string;
  price: number;
};

export type ReturnOrder = {
  order_name: string;
  email: string;
  portal_id: string;
  shop: string;
  refund_as_gift_card?: boolean;
  line_items: ReturnItem[];
  reasons: number[];
  upsell_exchanges?: UpsellExchange[];
};

export enum ErrorType {
  InvalidOrder = "invalid_order",
  OrderNotFulfilled = "order_not_fulfilled",
  OrderTooOld = "order_too_old",
  OrderAlreadyHasReturn = "order_already_has_return",
}

export type MoneySet = {
  shop_money: Money;
  presentment_money: Money;
};

export type CalculatedReturn = {
  return_value: MoneySet;
  available_for_exchange: MoneySet;
  exchange_value: MoneySet;
  exchange_bonus: MoneySet;
  refund_value: MoneySet;
  return_fee: MoneySet;
  requires_payment: boolean;
  required_payment: MoneySet;
};
